// frontend/src/components/LoadingIndicator/LoadingIndicator.jsx

import React from 'react';
import { useTranslation } from 'react-i18next';
import './LoadingIndicator.css';

const LoadingIndicator = ({ messages = {} }) => {
  const { t } = useTranslation();

  const translateTaskName = (taskKey) => {
    return t(`analysisTasks.${taskKey}`, { defaultValue: taskKey });
  };
  
  const renderMessage = (payload) => {
    // If the payload has a rawText override, return it directly!
    if (payload && payload.rawText) return payload.rawText;
    if (!payload || !payload.key) return null;
    
    const translatedParams = { ...payload.params };
    if (translatedParams.taskKey) {
      translatedParams.taskName = translateTaskName(translatedParams.taskKey);
    }

    return t(payload.key, translatedParams);
  };
  
  // --- THIS IS THE REFINED LOGIC ---
  const isMultiTaskView = messages && Object.keys(messages).length > 0 && !messages.general;

  return (
    <div className="loading-indicator">
      <div className="spinner"></div>
      
      {isMultiTaskView ? (
        // This view is for when parallel tasks are running
        <div className="multi-message-container">
          {Object.entries(messages).map(([key, payload]) => (
            <p key={key}>{renderMessage(payload)}</p>
          ))}
        </div>
      ) : (
        // This view handles the initial "general" messages like "Initiating..." and "Hashing..."
        <p>{messages.general ? renderMessage(messages.general) : 'Loading...'}</p>
      )}
    </div>
  );
};

export default LoadingIndicator;